<app-law-firm-search
	*ngIf="!lawFirm"
	class="w-full"
	[placeholder]="placeholder"
	[showClerk]="showClerk"
	(onSelectedLawfirm)="selectLawFirm($event)"
	(onCreateLawfirm)="createLawFirm($event)"
	(onSelectedLawyer)="selectLawyerFromIntitialSearch($event)"
	(onSelectedClerk)="selectClerk($event)"
	[label]="label"
></app-law-firm-search>
<div *ngIf="lawFirm">
	<app-firm-card
		[name]="lawFirm?.name"
		[address]="setAddress(lawFirm?.address)"
		[phone]="lawFirm?.phoneNumber"
		[fax]="lawFirm?.faxNumber"
		[email]="lawFirm?.email"
		member="LAWFIRM"
		memberType="Business"
		[hoverShadow]="hoverShadow"
		(dropdown)="lawFirmDropdownOptionSelect($event)"
		[testHook]="testHooks.FirmCard"
	>
	</app-firm-card>
	<div class="grid grid-cols-2 gap-x-1 mt-5">
		<div class="col-span-1">
			<app-lawyer
				class="mt-2 flex flex-1"
				[lawFirm]="lawFirm"
				(onSelectLawyer)="selectLawyer($event)"
				(onCreateOrUpdateLawyer)="createOrUpdateLawyer($event)"
				(onRemoveLawyer)="removeLawyer()"
				(onFocus)="_onFocus()"
				[ngClass]="{ 'mr-2': showClerk }"
			></app-lawyer>
		</div>

		<div class="col-span-1">
			<app-clerk
				*ngIf="showClerk"
				class="mt-2 ml-2 flex flex-1"
				[lawFirm]="lawFirm"
				[showClerk]="showClerk"
				(onSelectClerk)="selectClerk($event)"
				(onCreateOrUpdateClerk)="createOrUpdateClerk($event)"
				(onRemoveClerk)="removeClerk()"
				(onFocus)="_onFocus()"
			></app-clerk>
		</div>
	</div>
</div>
<div *ngIf="lawFirm && showFileNumber" class="mt-5">
	<app-input
		(debounce)="fileNumberChange($event)"
		[ngModel]="fileNumber"
		class="mr-3"
		label="File number"
		placeholder="File number"
		[testHook]="testHooks.FileNumber"
	></app-input>
</div>
